// work data

export const Work = [
  {
    id: 1,
    name: "Synthesis",
    description:
      "The Synthesis App is an integration of web and Machine Learning. This app uses Natural Language processing to extract key concepts from books and plots them into knowledge maps in a bid to reduce information overload om readers",
    tags: ["react","NLP", "ML",  "typescript", "material-ui", "styled-components"],

    demo: "https://thesynthesis.app/",
    github: "https://github.com/MikeAriyo",
  },
  {
    id: 2,
    name: "Trakio | React Covid Tracker",
    description:
      "Built with React JS, Material UI and Chart Js, Trakio is a Live Covid-19 tracker that allows users to stay up to date with the figures and current data on the pandemic",
    tags: ["react", "chartJs", "APIs"],

    demo: "https://tracker-3f612.web.app/",
    github: "https://github.com/MikeAriyo/Trakio",
  },
  {
    id: 3,
    name: "Tesla",
    description:
      "This project is a simple rebuild of Tesla's Landing Page",
    tags: ["react", "styled components"],

    demo: "https://teslarebuild.netlify.app",
    github: "https://github.com/MikeAriyo/tesla_rebuild",
  },

  {
    id: 4,
    name: "Vanilla Js QuizApp",
    description:
      "Quiz App built with vanilla Javascript. This project was aimed at improving my knowledge of pure javascript",
    tags: ["JavaScript", "DOM"],

    demo: "https://playquiznow.netlify.app/",
    github: "https://github.com/MikeAriyo/Quiz-App/tree/main/Quiz%20App",
  },
];
